import { createAsyncTypes } from 'utils/ActionCreator'

export const DATA_REQUEST_ASYNC = createAsyncTypes('DATA_REQUEST', 'ResolutionCenter/Resolution')
export const TOGGLE_COMMUNICATION_WIDGET = 'ResolutionCenter/Resolution/TOGGLE_COMMUNICATION_WIDGET'
